import utils, { IAPIHeaders } from '../API/utils';
import { AEM_ROUTES, REQUIRED_HTML_TAGS } from './constants';
import { getBrandContext } from '../brand/brandContext';

export interface IContentService {
  state: string;
  language: string;
  pageName: string;
}

export const fetchFromContentService = (
  pageName: string,
  language: string,
  state: string,
  isPageSpecific: boolean,
  headers?: IAPIHeaders,
): Promise<any> => {
  const data: IContentService = {
    state,
    language,
    pageName,
  };

  const { brandCode } = getBrandContext();
  const route = AEM_ROUTES.fetchDataFromContentService(
    data,
    isPageSpecific,
    brandCode,
  );

  return utils.fetch(route, {
    method: 'GET',
    data,
    headers,
  });
};

const shouldUseHTML = (key: string, pageName: string) => {
  if (REQUIRED_HTML_TAGS[pageName] && REQUIRED_HTML_TAGS[pageName][key]) {
    return true;
  }
  return false;
};

export const parseAll = (res: any, pageName: string, key?: string): any => {
  if (res) {
    if (typeof res === 'string' && key) {
      const shouldUse = shouldUseHTML(key, pageName);

      // parse html string to React dom
      return shouldUse ? res.trim() : removeHtmlTags(res.trim());
    } else {
      // parse whole object of AEM recursively
      const data: any = {};
      Object.keys(res).map((r) => {
        data[r] = parseAll(res[r], pageName, r);
      });
      return data;
    }
  } else return res;
};

export const removeSpaceFromHtmlTags = (html: string): string => {
  if (html) {
    return html.replace(/&nbsp;/g, '');
  }
  return '';
};

export const replaceQuotFromHtmlTags = (html: string): string => {
  if (html) {
    return html.replace(/&quot;/g, '"');
  }
  return '';
};

export const removeHtmlTags = (html: string): string => {
  if (html) {
    return html.replace(/<[^>]*>/g, '');
  }
  return '';
};

export const removePtagFromHtml = (html: string): string => {
  if (html) {
    return html.replace('<p>', '').replace('</p>', '');
  }
  return '';
};
